function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.0546875,25.28125 C18.5625,25.28125 18.921875,24.921875 18.921875,24.40625 L18.921875,14.7578125 L18.859375,13.0703125 L20.8828125,15.328125 L22.6640625,17.09375 C22.8203125,17.25 23.0390625,17.3515625 23.28125,17.3515625 C23.7578125,17.3515625 24.1171875,16.9921875 24.1171875,16.5 C24.1171875,16.2734375 24.03125,16.0625 23.84375,15.875 L18.6953125,10.71875 C18.5234375,10.5390625 18.2890625,10.4453125 18.0546875,10.4453125 C17.8125,10.4453125 17.578125,10.5390625 17.40625,10.71875 L12.265625,15.875 C12.078125,16.0625 11.9921875,16.2734375 11.9921875,16.5 C11.9921875,16.9921875 12.34375,17.3515625 12.8203125,17.3515625 C13.0703125,17.3515625 13.2890625,17.25 13.4453125,17.09375 L15.21875,15.328125 L17.25,13.0625 L17.1796875,14.7578125 L17.1796875,24.40625 C17.1796875,24.921875 17.5390625,25.28125 18.0546875,25.28125 Z",
  fill: "#3C4043",
  fillRule: "nonzero"
}));

var SvgArrowUp = function SvgArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-up.92ba5bef.svg";
export { ForwardRef as ReactComponent };